import React from "react"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import {
  mentionsContainer,
  mentionsTitle,
  mentionsSubTitle,
  imgPartenaire,
  orderedItem,
} from "../styles/mentions-legales.module.scss"
import { useBuildData } from "../hooks/use-build-data"
import logoTernum from "../images/ternumBFC.png"
import logoWordline from "../images/worldline-large.png"
import logoAtol from "../images/logo.svg"
import {
  Title,
  H1Title,
  Container,
} from "../styled-components/mentions-legales-styled"
import Ariane from "../components/Ariane/ariane"
import ContentTransformer from "../components/Transformers/content-transformer"
import Obfuscate from "react-obfuscate"
import PropTypes from "prop-types"

const MentionsLegales = ({ arianeDisplayed }) => {
  const data = useBuildData()
  const needTitle =
    process.env.THEME_GATSBY === "gatsby-theme-lantana" ||
    process.env.THEME_GATSBY === "gatsby-theme-catcus"
  return (
    <Layout message="Mentions légales">
      <SEO
        description="Sur cette page vous retrouvez les mentions légales de ce site internet"
        title="Mentions légales"
      />
      {arianeDisplayed && (
        <Ariane pageName="Mentions Légales" isListing={true} />
      )}
      <Container className={mentionsContainer}>
        {needTitle && (
          <H1Title className={mentionsTitle}>Mentions légales</H1Title>
        )}
        <Title className={mentionsTitle}>Mentions obligatoires</Title>
        <ul>
          <li>
            Dénomination sociale : <b>{data.mentions_settings.social_name}</b>
          </li>
          <li>
            Adresse du siège social :{" "}
            <b>{data.mentions_settings.adress_social_name}</b>
          </li>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel={data.mentions_settings.phone_number} />
            </b>
          </li>
          <li>
            Adresse électronique :{" "}
            <b>
              <Obfuscate email={data.mentions_settings.mail_adress} />
            </b>
          </li>
          <li>
            Forme juridique : <b>{data.mentions_settings.legal_form}</b>
          </li>
          <li>
            Capital social : <b>{data.mentions_settings.social_capital}</b>
          </li>
          <li>
            Site officiel :{" "}
            <a href={data.mentions_settings.official_web_site}>
              <b>{data.mentions_settings.official_web_site}</b>
            </a>
          </li>
          <li>
            Directeur de la publication :{" "}
            <b>{data.mentions_settings.director_publication}</b>
          </li>
          <li>
            Directeur de la rédaction :{" "}
            <b>{data.mentions_settings.director_redaction}</b>
          </li>
        </ul>
        <Title className={mentionsTitle}>Fournisseur</Title>
        <h3 className={mentionsSubTitle}>
          Territoires Numériques Bourgogne-Franche-Comté, GIP{" "}
        </h3>
        <img
          className={imgPartenaire}
          aria-hidden={true}
          alt={""}
          src={logoTernum}
          role="presentation"
        />
        <ul>
          <li>
            Dénomination sociale : <b>GIP TERRITOIRES NUMERIQUES BFC</b>
          </li>
          <li>
            Adresse du siège social : <b>3 rue de Suzon, 21000 Dijon, France</b>
          </li>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel="03 80 27 04 20" />
            </b>
          </li>
          <li>
            Site web :{" "}
            <a href="https://ternum-bfc.fr">
              <b>www.ternum-bfc.fr</b>
            </a>
          </li>
        </ul>
        <Title className={mentionsTitle}>Hébergeur</Title>
        <h3 className={mentionsSubTitle}>Worldline France, S.A</h3>
        <img
          className={imgPartenaire}
          aria-hidden={true}
          alt={""}
          src={logoWordline}
          role="presentation"
        />
        <ul>
          <li>
            Dénomination sociale : <b>Worldline France, S.A </b>
          </li>
          <li>
            Adresse du siège social :{" "}
            <b>River Ouest 80 Quai Voltaire 95870 Bezons, France</b>
          </li>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel="08 91 65 31 80" />
            </b>
          </li>
          <li>
            Site web :{" "}
            <a href="https://worldline.com">
              <b>www.worldline.com</b>
            </a>
          </li>
        </ul>
        <Title className={mentionsTitle}>Réalisation</Title>
        <h3 className={mentionsSubTitle}>Atol Conseils et Développements</h3>
        <img
          className={imgPartenaire}
          aria-hidden={true}
          alt={""}
          src={logoAtol}
          role="presentation"
        />
        <ul>
          <li>
            Dénomination sociale : <b>ATOL CONSEILS ET DÉVELOPPEMENTS</b>
          </li>
          <li>
            Adresse du siège social :{" "}
            <b>Route des terres d’or, 21220 Gevrey-chambertin, France</b>
          </li>
          <li>
            Téléphone :{" "}
            <b>
              <Obfuscate tel="03 80 68 81 68" />
            </b>
          </li>
          <li>
            Site web :{" "}
            <a href="https://atolcd.com">
              <b>www.atolcd.com</b>
            </a>
          </li>
        </ul>
        {data.mentions_settings.legal_mentions_sup.value !== "" && (
          <>
            <Title className={mentionsTitle}>
              Mentions légales supplémentaires
            </Title>
            <ContentTransformer
              content={data.mentions_settings.legal_mentions_sup.value}
            />
          </>
        )}

        <Title className={mentionsTitle}>
          Mentions relatives à l&apos;utilisation de cookies
        </Title>
        <p>
          Nous utilisons différents cookies sur le site pour améliorer
          l&apos;interactivité du site.
        </p>
        <ol>
          <li className={orderedItem}>
            Qu&apos;est-ce qu&apos;un &quot;cookie&quot; ?
          </li>
          <p style={{ marginBottom: "0", marginLeft: "-1.45rem" }}>
            Un cookie est un fichier texte déposé sur votre ordinateur lors de
            la visite d&#39;un site. Il permet de conserver des données
            utilisateur afin de faciliter la navigation et de permettre
            certaines fonctionnalités. Vous pouvez les activer ou les
            désactiver.
          </p>
          <a
            style={{ marginLeft: "-1.45rem" }}
            href="https://tarteaucitron.io/fr/"
          >
            En savoir plus sur les cookies, leur fonctionnement et les moyens de
            s&apos;y opposer
          </a>
          <li className={orderedItem}>
            Cookies nécessaires au site pour fonctionner
          </li>
          <p style={{ marginBottom: "0.5rem", marginLeft: "-1.45rem" }}>
            Ces cookies permettent au site de fonctionner de manière optimale et
            ils ne sont pas utilisés à des fins publicitaires.
          </p>
          <table
            summary="Liste des cookies nécessaires au fonctionnement du site"
            aria-describedby="Liste des cookies nécessaires au fonctionnement du site"
          >
            <thead>
              <tr>
                <th id="nom_cookie">Nom du cookie</th>
                <th id="finalite">Finalité</th>
                <th id="duree_conservation">Durée de conservation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td headers="nom_cookie">
                  AlertBool -- Stockée dans le sessionStorage
                </td>
                <td headers="finalite">
                  Mémoriser la fermeture du popup message important
                </td>
                <td headers="duree_conservation">
                  Durée d&apos;une session de navigation, à la fermeture de
                  l&apos;onglet les données sont effacées
                </td>
              </tr>
              <tr>
                <td headers="nom_cookie">Tarteaucitron</td>
                <td headers="finalite">
                  Stocker l&apos;autorisation d&apos;utilisation des cookies
                </td>
                <td headers="duree_conservation">Durée maximale de 13 mois</td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginBottom: "0.5rem",
              marginLeft: "-1.45rem",
              textAlign: "center",
            }}
          >
            Matomo &quot;outil de statistiques&quot;
          </p>
          <table
            summary="Liste des cookies Matomo nécessaires au fonctionnement du site"
            aria-describedby="Liste des cookies Matomo nécessaires au fonctionnement du site"
          >
            <thead>
              <tr>
                <th id="nom_cookie">Nom du cookie</th>
                <th id="finalite">Finalité</th>
                <th id="duree_conservation">Durée de conservation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td headers="nom_cookie">pk_session</td>
                <td headers="finalite">
                  Statistiques Matomo afin de stocker des données dans la
                  session en cours
                </td>
                <td headers="duree_conservation">1/2h</td>
              </tr>
              <tr>
                <td headers="nom_cookie">_pk_id</td>
                <td headers="finalite">
                  Statistiques Matomo concernant l&apos;utilisateur
                </td>
                <td headers="duree_conservation">13 mois</td>
              </tr>
              <tr>
                <td headers="nom_cookie">_pk_ref</td>
                <td headers="finalite">
                  Statistiques Matomo utilisées pour stocker les informations
                  d&apos;attribution, notamment le référent initialement utilisé
                  pour visiter le site Web
                </td>
                <td headers="duree_conservation">6 mois</td>
              </tr>
            </tbody>
          </table>
        </ol>
        <p style={{ marginBottom: "0.5rem" }}>
          Nous collectons également votre adresse IP, afin de déterminer la
          ville depuis laquelle vous vous connectez. Celle-ci est immédiatement
          anonymisée après utilisation. La collectivité ne peut donc en aucun
          cas remonter par ce biais à une personne physique.
        </p>
        <p>
          Les données personnelles recueillies (les cookies) sont conservées par
          la collectivité pour une durée de 13 mois. Elles ne sont pas cédées à
          des tiers ni utilisées à d&apos;autres fins.
        </p>
        {data.mentions_settings.info_cookies_sup.value !== "" && (
          <>
            <p style={{ marginBottom: "0.5rem" }}>
              Complément d&apos;informations sur les cookies :
            </p>
            <ContentTransformer
              content={data.mentions_settings.info_cookies_sup.value}
            />
          </>
        )}
        <p>
          Vous pouvez choisir de refuser les cookies et l’analyse statistique de
          vos données de navigation.
        </p>
        <p>
          Pour faire ce choix, utilisez :{" "}
          <a href="https://tarteaucitron.io/fr/">lien vers Tartaucitron</a>
        </p>
        <Title id="accessibilite" className={mentionsTitle}>
          Accessibilité du site
        </Title>
        <ContentTransformer
          content={data.mentions_settings.info_accessibility.value}
        />
      </Container>
    </Layout>
  )
}

MentionsLegales.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default MentionsLegales
